import { render, staticRenderFns } from "./AlertingWebhook.vue?vue&type=template&id=5c2a9d83&scoped=true"
import script from "./AlertingWebhook.vue?vue&type=script&lang=js"
export * from "./AlertingWebhook.vue?vue&type=script&lang=js"
import style0 from "./AlertingWebhook.vue?vue&type=style&index=0&id=5c2a9d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a9d83",
  null
  
)

export default component.exports